import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ImageAtoms, Pill } from "@vfit/shared/atoms";
import { CardContainerLarge, ContentContainerLarge, CreatorLarge, PillElement, TitleLarge, TopicLarge, TopImageContainerLarge } from "../../articleCard.style";
export var ArticleCardLarge = function(param) {
    var title = param.title, topic = param.topic, creator = param.creator, backgroundImg = param.backgroundImg, pillText = param.pillText, isExternalImages = param.isExternalImages, ignoreSize = param.ignoreSize;
    return /*#__PURE__*/ _jsxs(CardContainerLarge, {
        ignoreSize: ignoreSize,
        children: [
            backgroundImg && title && /*#__PURE__*/ _jsx(TopImageContainerLarge, {
                ignoreSize: ignoreSize,
                children: /*#__PURE__*/ _jsx(ImageAtoms, {
                    nameCard: title,
                    image: backgroundImg,
                    width: 100,
                    objectFit: "cover",
                    external: isExternalImages,
                    style: {
                        borderRadius: "20px 20px 0 0"
                    }
                })
            }),
            pillText && /*#__PURE__*/ _jsxs(PillElement, {
                children: [
                    /*#__PURE__*/ _jsx(Pill, {
                        label: pillText
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ _jsxs(ContentContainerLarge, {
                children: [
                    topic && /*#__PURE__*/ _jsx(TopicLarge, {
                        children: topic
                    }),
                    title && /*#__PURE__*/ _jsx(TitleLarge, {
                        children: title
                    }),
                    creator && /*#__PURE__*/ _jsx(CreatorLarge, {
                        children: creator
                    })
                ]
            })
        ]
    });
};
